import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center align-center py-3 px-1" }

interface Props {
  text?: boolean | string
  color?: string
}
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    text: { type: [Boolean, String], default: false },
    color: { default: 'black' }
  },
  setup(__props: any) {

const props = __props as { text: boolean | string, color: string }



return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_divider),
    (props.text)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(`mx-2 text-${__props.color}`)
        }, _toDisplayString(props.text), 3))
      : _createCommentVNode("", true),
    (props.text)
      ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})